// src/components/Modal.js
import React from 'react';
import '../styles/Modal.css'; // Add styles for your modal

const PublicationsModal = ({ isOpen, onClose, content }) => {
    if (!isOpen) return null;

    const handleCopyToClipboard = () => {
        navigator.clipboard.writeText(content)
            .then(() => {
                alert("BibTeX copied to clipboard!"); // Optional: Notification on successful copy
            })
            .catch(err => {
                console.error("Failed to copy: ", err);
            });
    };

    return (
        <div className="modal-overlay">
            <div className="modal-content">
                <button className="modal-close" onClick={onClose}>
                    <span role="img" aria-label="close">❌</span> {/* Close icon */}
                </button>
                <div className="pre-container">
                    <button className="modal-copy" onClick={handleCopyToClipboard} title="Copy to clipboard">
                        <span role="img" aria-label="copy clipboard">📋</span> {/* Copy icon (clipboard symbol) */}
                    </button>
                    <pre>{content}</pre> {/* Display BibTeX content */}
                </div>
            </div>
        </div>
    );
};

export default PublicationsModal;
